import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { environment } from '../environments/environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { APP_BASE_HREF, LocationStrategy, PathLocationStrategy, PlatformLocation } from '@angular/common';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';

import { routes } from './app.routes';


// Cognito Module Imports
import { APPLICATION_NAME, ALLOW_SCREENAUTH, APIGATEWAY_CONFIG, authInterceptor, getBaseHref, COGNITO_CONFIG_HA } from '@gea-mes/cognito';
import { appinfo } from './appinfo'; // Providers information about this application


// Navbar Module Imports
import { GEA_MES_NAVBAR_APPLICATION_NAME,GEA_MES_NAVBAR_MENU_SERVICE,GEA_MES_NAVBAR_ENV_PROD_STATUS, GEA_ENVIROMENT, NavItem } from '@gea-mes/navbar';

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes), 
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    // Cognito Module Injections
    { provide: APIGATEWAY_CONFIG, useValue: environment.apiGateway },
    { provide: APP_BASE_HREF, useFactory: getBaseHref, deps: [PlatformLocation]},
    { provide: COGNITO_CONFIG_HA, useValue: environment.cognitoOptionsHA },
    { provide: APPLICATION_NAME, useValue: appinfo.name.toUpperCase() },
    { provide: ALLOW_SCREENAUTH, useValue: environment.AllowScreenAuth },
    provideHttpClient(withInterceptors([authInterceptor])), // HTTP Interceptor to inject Authorization token
    provideAnimations(), // Used by Toastr display and Navbar
    provideToastr(), // Used by Toastr display 
    // Navbar Module Injections
    { provide: GEA_MES_NAVBAR_APPLICATION_NAME,useValue: appinfo.name.toUpperCase()}, 
    { provide: GEA_MES_NAVBAR_ENV_PROD_STATUS, useValue: environment.production },
    { provide: GEA_ENVIROMENT, useValue: environment },
    { provide: GEA_MES_NAVBAR_MENU_SERVICE, useValue: new BehaviorSubject<NavItem[]>([]) }
  ]
};
